// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-label{
    color: #D0D0D0;
    font-size: 12px;
}

.resetFilterButton{
    color: #3387DF;
    font-size: 16px;
    font-weight: 400;
    font-weight: bold;
    border:1px solid #3387DF;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 30px;
    padding-right: 30px;
    border-radius: 50px;
    margin-right: 10px;
}

.resetFilterButton:hover{
    cursor: pointer;
}

.applyFilterButton{
    color: white;
    font-size: 16px;
    font-weight: 400;
    font-weight: bold;
    background-color: #3387DF;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 30px;
    padding-right: 30px;
    border-radius: 50px;
}

.applyFilterButton:hover{
    cursor: pointer;
}

.cancelFilterResetModalButton{
    color: #005CBC;
    font-size: 16px;
    font-weight: 400;
    font-weight: bold;
    border:1px solid #005CBC;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
    border-radius: 50px;
    margin-right: 10px;
}

.cancelFilterResetModalButton:hover{
    cursor: pointer;
}

.resetFilterModalButton{
    color: white;
    font-size: 16px;
    font-weight: 400;
    font-weight: bold;
    background-color: #005CBC;
    border:1px solid #005CBC;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
    border-radius: 50px;
    margin-right: 10px;
}

.resetFilterModalButton:hover{
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/ForecastAnalysisFilter/ForecastAnalysisFilter.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".select-label{\n    color: #D0D0D0;\n    font-size: 12px;\n}\n\n.resetFilterButton{\n    color: #3387DF;\n    font-size: 16px;\n    font-weight: 400;\n    font-weight: bold;\n    border:1px solid #3387DF;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-left: 30px;\n    padding-right: 30px;\n    border-radius: 50px;\n    margin-right: 10px;\n}\n\n.resetFilterButton:hover{\n    cursor: pointer;\n}\n\n.applyFilterButton{\n    color: white;\n    font-size: 16px;\n    font-weight: 400;\n    font-weight: bold;\n    background-color: #3387DF;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-left: 30px;\n    padding-right: 30px;\n    border-radius: 50px;\n}\n\n.applyFilterButton:hover{\n    cursor: pointer;\n}\n\n.cancelFilterResetModalButton{\n    color: #005CBC;\n    font-size: 16px;\n    font-weight: 400;\n    font-weight: bold;\n    border:1px solid #005CBC;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-left: 20px;\n    padding-right: 20px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    border-radius: 50px;\n    margin-right: 10px;\n}\n\n.cancelFilterResetModalButton:hover{\n    cursor: pointer;\n}\n\n.resetFilterModalButton{\n    color: white;\n    font-size: 16px;\n    font-weight: 400;\n    font-weight: bold;\n    background-color: #005CBC;\n    border:1px solid #005CBC;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-left: 20px;\n    padding-right: 20px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    border-radius: 50px;\n    margin-right: 10px;\n}\n\n.resetFilterModalButton:hover{\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
